import { Api } from "../config/request";

/**
 * API function to submit user feedback
 * @param {object} data - The feedback data (name, email, feedback)
 * @returns {Promise<object>} - The API response
 */
const submitFeedback = async (data) => {
    let response = await Api.PostRequest("/submitFeedback", data);
    return response.data;
};

const feedbackApi = {
    submitFeedback,
};

export default feedbackApi;
